window.primaryMenu = () => {
	/**
	 * Mega menu hover first child menu if not hover on any menu item.
	 *
	 * @return {void}
	 */
	const megaMenuInitHover = () => {
		const primaryMenuWrap = document.getElementById( "primary-nav" );

		if ( null !== primaryMenuWrap ) {
			const allMegaMenus =
				primaryMenuWrap.querySelectorAll( ".has-mega-menu" );

			if ( null !== allMegaMenus ) {
				allMegaMenus.forEach( ( megaMenu ) => {
					const firstMenuItem = megaMenu.querySelector(
						".sub-menu > li:first-child",
					);
					firstMenuItem.classList.add( "is-hover" );

					const siblingMenuItems = Array.from(
						firstMenuItem.parentNode.children,
					).filter( ( item ) => item !== firstMenuItem );

					siblingMenuItems.forEach( ( item ) => {
						item.addEventListener( "mouseenter", () => {
							firstMenuItem.classList.remove( "is-hover" );
						} );

						item.addEventListener( "mouseleave", () => {
							if (
								!siblingMenuItems.some( ( sibling ) =>
									sibling.matches( ":hover" ),
								)
							) {
								firstMenuItem.classList.add( "is-hover" );
							}
						} );
					} );
				} );
			}
		}
	};

	/**
	 * Mobile menu toggle.
	 *
	 * @return {void}
	 */
	function mobileMenuToggle() {
		const menuBtn = document.querySelector( ".mobile-menu-toggle" );

		if ( null !== menuBtn ) {
			document.addEventListener( "click", ( event ) => {
				if ( event.target.closest( ".mobile-menu-toggle" ) ) {
					event.preventDefault();

					document.documentElement.classList.toggle(
						"mobile-menu-active",
					);
					document.body.classList.toggle( "mobile-menu-active" );
					menuBtn.classList.toggle( "active" );

					setTimeout( () => {
						if ( !menuBtn.classList.contains( "active" ) ) {
							document
								.querySelectorAll( ".primary-menu .sub-menu" )
								.forEach( ( subMenu ) => {
									subMenu.classList.remove( "active" );
									subMenu.classList.remove( "oh-active" );
									document
										.querySelector( ".primary-menu" )
										.classList.remove( "oh-active" );
								} );
						}
					}, 100 );
				}
			} );
		}
	}

	/**
	 * Clone menu to child.
	 *
	 * Clone the parent menu and add a back anchor at the top of the child menu.
	 *
	 * @return {void}
	 */
	function cloneMenuToChild() {
		const menuWrap = document.getElementById( "primary-nav" );

		if ( null === menuWrap ) {
			return false;
		}

		const allMenuWithChild = menuWrap.querySelectorAll(
			".menu-item-has-children",
		);

		if ( null === allMenuWithChild ) {
			return false;
		}

		allMenuWithChild.forEach( ( menu ) => {
			const anchorText = menu.querySelector( "a" ).textContent;
			const liEl = document.createElement( "li" );
			const anchor = document.createElement( "a" );

			liEl.classList.add( "has-back-link" );
			anchor.classList.add( "back" );
			anchor.setAttribute( "href", "#" );
			anchor.textContent = anchorText;

			liEl.appendChild( anchor );

			if ( null === menu.querySelector( ".has-back-link" ) ) {
				// phpcs:ignore WordPressVIPMinimum.JS.HTMLExecutingFunctions.prepend
				menu.querySelector( ".sub-menu" ).prepend( liEl );
			}

			document.addEventListener( "click", ( event ) => {
				if ( event.target.classList.contains( "back" ) ) {
					event.preventDefault();
					event.target
						.closest( ".sub-menu" )
						.classList.remove( "active" );

					if ( null !== event.target.closest( ".oh-active" ) ) {
						event.target
							.closest( ".oh-active" )
							.classList.remove( "oh-active" );
					}
				}
			} );
		} );
	}

	/**
	 * Add click event to open child menu on mobile.
	 *
	 * Uses a 300ms debounce to prevent accidental clicks.
	 *
	 * @return {void}
	 */
	function openChildMenu() {
		const menuWrap = document.getElementById( "primary-nav" );

		if ( null === menuWrap ) {
			return false;
		}

		const allMenuWithChild = menuWrap.querySelectorAll(
			".menu-item-has-children",
		);

		if ( null === allMenuWithChild ) {
			return false;
		}

		const debouncedClickHandler = ( event ) =>
			debounce( handleSubMenuClick( event ), 300 );
		document.removeEventListener( "click", debouncedClickHandler );
		document.addEventListener( "click", ( event ) =>
			debouncedClickHandler( event ),
		);
	}

	/**
	 * Handle clicks on sub-menu items.
	 *
	 * If the screen size is larger than 1025px, this function does nothing.
	 *
	 * If the target element is a direct child of a `.menu-item-has-children` element,
	 * this function prevents the default link behavior and toggles the `active` class
	 * on the sibling `.sub-menu` element. It also adds the `oh-active` class to the
	 * parent element and the `.primary-menu` element.
	 *
	 * @param {object} event The click event.
	 *
	 * @return {void}
	 */
	function handleSubMenuClick( event ) {
		if ( window.outerWidth >= 1025 ) {
			return false;
		}

		if ( event.target.matches( ".menu-item-has-children > a" ) ) {
			event.preventDefault();
			event.target.parentNode.parentNode.scrollTo( 0, 0 );
			event.target.nextElementSibling.classList.toggle( "active" );
			event.target.parentNode.parentNode.classList.add( "oh-active" );
			document.querySelector( ".primary-menu" ).classList.add( "oh-active" );
		}
	}

	/**
	 * A function wrapper to debounce the passed function.
	 *
	 * Takes a function and a delay in milliseconds as arguments. The returned
	 * function will only call the passed function after the specified delay
	 * has passed since the last time the returned function was called.
	 *
	 * @param {function} func The function to debounce.
	 * @param {number} delay The delay in milliseconds.
	 *
	 * @return {function} The debounced function.
	 */
	function debounce( func, delay ) {
		let timer;
		return function () {
			const context = this;
			const args = arguments;
			clearTimeout( timer );
			timer = setTimeout( () => {
				func.apply( context, args );
			}, delay );
		};
	}

	/**
	 * Handle integrations menu hover behavior
	 */
	function integrationsMenuBehavior() {
		const integrationsMenu = document.querySelector(
			".menu-item-integrations",
		);

		if ( !integrationsMenu ) return;

		const subMenu = integrationsMenu.querySelector( ".sub-menu" );
		const menuItems = subMenu ? subMenu.querySelectorAll( ".menu-item" ) : [];

		if ( menuItems.length === 0 ) return;

		// Function to show first item as default when no item is hovered
		const showDefaultFirstItem = () => {
			// Clear all classes first
			menuItems.forEach( ( item ) => {
				item.classList.remove( "first-active" );
			} );
			// Add first-active to the first item
			menuItems[0].classList.add( "first-active" );
		};

		// Function to clear all states
		const clearAllStates = () => {
			menuItems.forEach( ( item ) => {
				item.classList.remove( "first-active" );
			} );
		};

		// When parent integrations menu is hovered, show first item as active initially
		integrationsMenu.addEventListener( "mouseenter", () => {
			showDefaultFirstItem();
		} );

		// When parent integrations menu is left, clean up all classes
		integrationsMenu.addEventListener( "mouseleave", () => {
			clearAllStates();
		} );

		// Add listeners to submenu to detect when we're in the menu area but not on specific items
		if ( subMenu ) {
			subMenu.addEventListener( "mouseenter", ( e ) => {
				// If we're entering the submenu but not on a specific menu item, show first item
				if ( e.target === subMenu ) {
					showDefaultFirstItem();
				}
			} );
		}

		menuItems.forEach( ( item, index ) => {
			item.addEventListener( "mouseenter", () => {
				// Clear all states first
				clearAllStates();
				// Add hovered class to current item
				item.classList.add( "hovered" );
			} );

			item.addEventListener( "mouseleave", ( e ) => {
				// Check if we're moving to the content wrapper of the same item
				const contentWrapper = item.querySelector(
					".menu-item-content-wrapper",
				);
				if (
					contentWrapper &&
					contentWrapper.contains( e.relatedTarget )
				) {
					// Don't clear states if moving to content wrapper, just maintain current item's state
					item.classList.remove( "hovered" );
					item.classList.add( "first-active" );
					return;
				}

				// Remove hovered class from current item
				item.classList.remove( "hovered" );

				// Use setTimeout to allow for mouse movement between elements
				setTimeout( () => {
					// If we're still in the integrations menu but not hovering any specific item
					const anyItemHovered = Array.from( menuItems ).some(
						( menuItem ) => menuItem.matches( ":hover" ),
					);

					if ( integrationsMenu.matches( ":hover" ) && !anyItemHovered ) {
						showDefaultFirstItem();
					}
				}, 50 );
			} );

			// Add event listeners to content wrapper to maintain active state
			const contentWrapper = item.querySelector(
				".menu-item-content-wrapper",
			);
			if ( contentWrapper ) {
				contentWrapper.addEventListener( "mouseenter", () => {
					// Ensure first-active is on this item when hovering its content
					clearAllStates();
					item.classList.add( "first-active" );
				} );

				contentWrapper.addEventListener( "mouseleave", ( e ) => {
					// Check if we're moving back to the menu item
					if ( item.contains( e.relatedTarget ) ) {
						// Moving back to the menu item, restore hovered state
						item.classList.remove( "first-active" );
						item.classList.add( "hovered" );
						return;
					}

					// Moving away from content wrapper
					item.classList.remove( "first-active" );

					// Use setTimeout to check if we should show default
					setTimeout( () => {
						const anyItemHovered = Array.from( menuItems ).some(
							( menuItem ) => menuItem.matches( ":hover" ),
						);
						if (
							integrationsMenu.matches( ":hover" ) &&
							!anyItemHovered
						) {
							showDefaultFirstItem();
						}
					}, 50 );
				} );
			}
		} );
	}

	/**
	 * Brand Menu Visibility Handler
	 *
	 * Shows/hides the brand-menu-container-left and ::before elements
	 * based on when the .our-brands-menu-trigger section comes into view
	 *
	 * @return {void}
	 */
	function brandMenuVisibility() {
		const trigger = document.querySelector( ".our-brands-menu-trigger" );

		if ( !trigger ) {
			console.warn(
				"our-brands-menu-trigger element not found. Brand menu will remain hidden.",
			);
			return;
		}

		let hasTriggered = false; // Track if menu has been triggered once

		/**
		 *
		 */
		function handleScroll() {
			const windowHeight = window.innerHeight;
			const triggerTopPosition = trigger.offsetTop;
			const currentScrollPosition = window.pageYOffset;

			// Check if we've scrolled to the trigger point
			const triggerActivationPoint =
				triggerTopPosition - windowHeight * 0.1;

			if ( currentScrollPosition >= triggerActivationPoint ) {
				// We've reached the trigger point - show menu and mark as triggered
				hasTriggered = true;
				document.body.classList.add( "brands-menu-visible" );
			} else if (
				hasTriggered &&
				currentScrollPosition < triggerActivationPoint
			) {
				// We've scrolled back UP past the trigger point - hide menu
				hasTriggered = false;
				document.body.classList.remove( "brands-menu-visible" );
			}
			// If we're below the trigger but haven't triggered yet, or we're above and already hidden, do nothing
		}

		window.addEventListener( "scroll", handleScroll, { passive: true } );
		handleScroll(); // Check initial state
	}

	/**
	 * Call above functions.
	 */
	megaMenuInitHover();
	integrationsMenuBehavior();
	brandMenuVisibility();
	mobileMenuToggle();
	openChildMenu();

	if ( window.outerWidth <= 1024 ) {
		cloneMenuToChild();
	}

	window.addEventListener( "resize", function () {
		if ( window.outerWidth <= 1024 ) {
			cloneMenuToChild();
		}

		// Remove back link on desktop view.
		if ( window.outerWidth >= 1025 ) {
			document
				.querySelectorAll( ".has-back-link" )
				.forEach( function ( backLink ) {
					backLink.remove();
				} );

			document.querySelectorAll( ".oh-active" ).forEach( function ( link ) {
				link.classList.remove( "oh-active" );
			} );

			document.documentElement.classList.remove( "mobile-menu-active" );
			document.body.classList.remove( "mobile-menu-active" );
			
			const mobileMenuToggle = document.querySelector( ".mobile-menu-toggle" );
			if ( mobileMenuToggle ) {
				mobileMenuToggle.classList.remove( "active" );
			}
			
			document
				.querySelectorAll( ".primary-menu .sub-menu" )
				.forEach( ( subMenu ) => {
					subMenu.classList.remove( "active" );
					subMenu.classList.remove( "oh-active" );
					const primaryMenu = document.querySelector( ".primary-menu" );
					if ( primaryMenu ) {
						primaryMenu.classList.remove( "oh-active" );
					}
				} );
		}
	} );
};
